import { LANGUAGES } from '../constants/i18nConstants.js'

const DEFAULT_LOCALE = 'en'

export const localesTypes = {
  user: 'locale',
  system: 'systemLocale'
}
export const isSupportedLocale = locale => LANGUAGES.map(({ code }) => code).includes(locale.toLowerCase())
/**
 * Sets the user locale in the localStorage.
 * @param {*} locale
 * @param type
 * @param skipChecking
 */
export const setLocale = (locale, type = localesTypes.user, skipChecking = false) => {
  if (skipChecking) {
    localStorage.setItem(type, locale.toLowerCase())
    return locale
  }
  locale = isSupportedLocale(locale) ? locale.toLowerCase() : DEFAULT_LOCALE
  localStorage.setItem(type, locale)
  return locale
}

/**
 * Returns the user locale from the localStorage.
 * @param type
 * @returns
 */
export const getLocale = (type = localesTypes.user) => {
  return localStorage.getItem(type)
}

export const convertTranslationArrayToDict = json => {
  return json.reduce((acc, item) => {
    acc[item.key] = item.translation
    return acc
  }, {})
}

export const convertDictToTranslationArray = dict => {
  return Object.keys(dict).map(key => ({ key, translation: dict[key] }))
}

export function getBrowserLanguage(ctx) {
  // SSR: ctx.req is available
  if (ctx?.req?.headers) {
    const acceptLanguage = ctx.req.headers['accept-language']
    if (acceptLanguage) {
      // Parse the header, e.g., "en-US,en;q=0.9"
      return acceptLanguage.split(',')[0].split('-')[0]
    }
  }
  // Client-side: use browser API
  if (typeof window !== 'undefined' && window.navigator) {
    const navigator = window.navigator
    return navigator.languages && navigator.languages.length
      ? navigator.languages[0].split('-')[0]
      : navigator.language
        ? navigator.language.split('-')[0]
        : navigator.userLanguage
          ? navigator.userLanguage.split('-')[0]
          : 'en'
  }
  // Default fallback
  return 'en'
}

export const isSupportedLanguage = locale => LANGUAGES.map(lang => lang.code).includes(locale.toLowerCase())
